import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKosovo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_261)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.27105 7.30439L5.53008 8.10164H6.3682L5.69015 8.59425L5.94914 9.39136L5.27105 8.89875L4.5929 9.39136L4.85198 8.59425L4.17389 8.10164H5.01197L5.27105 7.30439Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.87976 6.52181L8.13879 7.31902H8.97692L8.29887 7.81162L8.55786 8.60873L7.87976 8.11612L7.20167 8.60873L7.4607 7.81162L6.78265 7.31902H7.62078L7.87976 6.52181Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4884 5.73919L10.7474 6.53639H11.5856L10.9075 7.02905L11.1665 7.82616L10.4884 7.3335L9.81031 7.82616L10.0693 7.02905L9.3913 6.53639H10.2294L10.4884 5.73919Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7289 7.30439L18.4699 8.10164H17.6318L18.3099 8.59425L18.0508 9.39136L18.7289 8.89875L19.4071 9.39136L19.148 8.59425L19.8261 8.10164H18.988L18.7289 7.30439Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1203 6.52181L15.8613 7.31902H15.0231L15.7012 7.81162L15.4422 8.60873L16.1203 8.11612L16.7984 8.60873L16.5394 7.81162L17.2174 7.31902H16.3793L16.1203 6.52181Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5116 5.73919L13.2526 6.53639H12.4144L13.0925 7.02905L12.8335 7.82616L13.5116 7.3335L14.1897 7.82616L13.9306 7.02905L14.6087 6.53639H13.7706L13.5116 5.73919Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.087 12.5217L12 9.91303L10.9565 10.4348V11.4782L9.39132 12.5217H8.34784V13.8698C9.87728 14.4891 10.9565 15.9877 10.9565 17.7391H12V16.6957L13.0435 15.6522L14.087 16.6957L15.1305 15.6522V14.6087L16.1739 13.0435L14.087 12.5217Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_261",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgKosovo;
